import { Edit, MarkEmailRead } from '@mui/icons-material'
import { Stack, Switch, Typography } from '@mui/material'

import { preview } from '@/components/form/preview'

import type { NotificationFormType } from '@/notificationForms'
import { useTexts } from './../useTexts'

interface Props {
  notification: NotificationFormType
  onEdit: () => void
  onTest: () => void
  onToggle: () => void
  available: boolean
  enabled: boolean
  subtitle: string
  title: string
}

export function Header(props: Props) {
  const { title, subtitle, onEdit, enabled, available, notification, onTest, onToggle } = props

  const texts = useTexts()

  return (
    <preview.Header title={title} subtitle={subtitle} testId={`${notification}-view`}>
      <Stack direction="row" justifyContent="space-between">
        <preview.ActionBar>
          <preview.ActionBarItem
            icon={<Edit />}
            onClick={onEdit}
            label={texts.edit}
            disableWhenReadOnly={false}
            tooltip={texts.edit}
            testId="edit-button"
            data-trackid="edit-button"
            disabled={!available}
          />
          <preview.ActionBarItem
            icon={<MarkEmailRead />}
            onClick={onTest}
            label={texts.test}
            disableWhenReadOnly={false}
            tooltip={texts.test}
            testId="test-notification"
            data-trackid="test-notification"
            disabled={!available}
          />
        </preview.ActionBar>
        <Stack direction="row" alignItems="center" spacing={1}>
          <Typography variant="body1">{texts.toggelNotification(enabled)}</Typography>
          <Switch
            className={`pendo-${notification}-toggle-notification`}
            data-testid={`toggle-notification`}
            data-trackid={`toggle-notification`}
            onClick={onToggle}
            disabled={!available}
            checked={enabled}
          />
        </Stack>
      </Stack>
    </preview.Header>
  )
}
